module.exports = __webpack_public_path__ + "static/media/12.2a401ff5.png";